module.exports = __webpack_public_path__ + "static/circle_bg-b67b5e5fd349d398a5da445f5ba8a2cd.png";